import React, { useEffect, useState, useRef } from "react";
import "./VideoCallPreview.css";
import chill from "../../../icons/photos/chillLogo.png";
import { BsCameraFill, BsMicFill } from "react-icons/bs";
import InputField from "../../../jsx/components/fields/inputField";
import GreenButton from "../../../jsx/components/button/greenButton";
import { useSelector, useDispatch } from "react-redux";
import { getParticipantsApi } from "../../../service/api/video/getParticipant";
import PrimaryButton from "../../../jsx/components/button/primaryButton";
import { Modal } from "react-bootstrap";
import googleImg from "../../../media/images/googleImg.jpg"
import { setDownloadAppBar, setRecordingPermission, setUserProfileTab } from "../../../feature/userData/userData";
import { ticketDetailsApi } from "../../../service/api/ticket/getTicketDetails";
import ResponceToaster from "../../../jsx/components/responceToaster/responceToaster";
import { saveCallDurationApi } from "../../../service/api/video/saveCallDuration";
import serviceImg from '../../../media/images/serviceImg.gif'
import { useNavigate } from "react-router-dom";

const VideoCallPreview = ({
  onChange,
  value,
  errorOccured,
  handleSubmit,
  isLoading,
  onDeviceSelection,
  participantNameArr,
}) => {
  const dispatch = useDispatch();
  const { role, recordingPermission, userName, permissionArr } = useSelector((state) => state.user);
  const { authorized } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  
  const permissionArray = permissionArr[0] || []

  const [devices, setDevices] = useState({ audio: [], video: [] });
  const [selectedAudioDevice, setSelectedAudioDevice] = useState("");
  const [selectedVideoDevice, setSelectedVideoDevice] = useState("");
  const [audioDenied, setAudioDenied] = useState(false);
  const [videoDenied, setVideoDenied] = useState(false);
  const [participantsData, setParticipantsData] = useState([]);
  const [permissionsModalVisible, setPermissionsModalVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentStream, setCurrentStream] = useState(null); // Track the active stream
  const videoRef = useRef(null);
    const [audioLevel, setAudioLevel] = useState(0);
    const audioContextRef = useRef(null);
    const analyserRef = useRef(null);
    const animationFrameIdRef = useRef(null);
 const [serviceDetailsObj, setServiceDetailsObj] = useState({});

 const [responceMsg, setResponceMsg] = useState("");
   const [toasterType, setToasterType] = useState();
   const [handleToaster, setHandleToaster] = useState(false);

   const [ saveCallDurationLoading, setSaveCallDurationLoading] = useState(false);
   const [paymentErrorModalTrigger, setPaymentErrorModalTrigger] = useState(false);
   const [paymentErrorStatusCode, setPaymentErrorStatusCode] = useState(0);

  // Check wether the device is desktop/android/iOS
  const [deviceType, setDeviceType] = useState(
    window.innerWidth < 768 ? 'mobile' : 'desktop'
  );
  const [osType, setOsType] = useState('android'); // Default to 'android'

  useEffect(() => {
    dispatch(setDownloadAppBar(false));
  }, []);


  useEffect(() => {
    const handleResize = () => {
      setDeviceType(window.innerWidth < 768 ? 'mobile' : 'desktop');
    };

    const detectOs = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      if (/android/i.test(userAgent)) {
        setOsType('android');
      } else if (/iphone|ipod/i.test(userAgent)) {
        setOsType('ios');
      } else {
        setOsType('android'); // Default to Android if no match
      }
    };

    detectOs();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);




  useEffect(() => {
    if (localStorage.getItem("roomCode")) {
      const data = { video_token_chr: localStorage.getItem("roomCode") };
      dispatch(getParticipantsApi(data, (res) => setParticipantsData(res.data.data)));
    }
  }, [dispatch, localStorage.getItem("roomCode"), participantNameArr]);



  const stopCurrentStream = async () => {
    if (currentStream) {
      currentStream.getTracks().forEach((track) => track.stop()); // Stop all tracks
      setCurrentStream(null); // Clear the stream from state
      if (videoRef.current) videoRef.current.srcObject = null; // Reset the video element
    }
  };

  const checkPermissions = async () => {
    try {
      const [audioPermission, videoPermission] = await Promise.all([
        navigator.permissions.query({ name: "microphone" }),
        navigator.permissions.query({ name: "camera" }),
      ]);

      if (audioPermission.state === "granted" && videoPermission.state === "granted") {
        requestMediaPermissions();
      } else {
        setPermissionsModalVisible(true);
      }
    } catch (error) {
      console.error("Error checking permissions:", error);
      setPermissionsModalVisible(true);
    }
  };
  const handleRetry = (type) => {
    setShowModal(true)
    requestMediaPermissions(type);
  };

  // const requestMediaPermissions = async () => {
  //   try {
  //     const constraints = {
  //       audio: true,
  //       video: { facingMode: { ideal: role === 2 ? "environment" : "user" }, },
  //     };

  //     await stopCurrentStream(); // Stop any existing stream before requesting a new one

  //     const stream = await navigator.mediaDevices.getUserMedia(constraints);
  //     setCurrentStream(stream); // Store the new stream

  //     const devices = await navigator.mediaDevices.enumerateDevices();
  //     const audioDevices = devices.filter((d) => d.kind === "audioinput");
  //     const videoDevices = devices.filter((d) => d.kind === "videoinput");

  //     setDevices({ audio: audioDevices, video: videoDevices });

  //     if (audioDevices.length > 0) setSelectedAudioDevice(audioDevices[0].deviceId);
  //     if (videoDevices.length > 0) setSelectedVideoDevice(videoDevices[0].deviceId);

  //     setPermissionsModalVisible(false);
  //     setAudioDenied(false);
  //     setVideoDenied(false);

  //     if (videoRef.current) videoRef.current.srcObject = stream;
  //   } catch (error) {
  //     console.error("Error requesting media permissions:", error);
  //     setShowModal(true);
  //     setAudioDenied(true);
  //     setVideoDenied(true);
  //   }
  // };
const requestMediaPermissions = async () => {
  try {
    let constraints = {
      audio: true,
      video: true,
      //  video: {
      //   facingMode: { ideal: role === 2 ? "environment" : "user" },
      // },
    };

    // Stop any existing stream before requesting a new one
    await stopCurrentStream();

    let stream;
    try {
      // First, try with the ideal facingMode
      stream = await navigator.mediaDevices.getUserMedia(constraints);
    } catch (error) {
      // If ideal facingMode fails, try a generic video constraint
      console.warn("Failed to get video with ideal facingMode. Trying generic video: true", error);
      constraints.video = true;
      stream = await navigator.mediaDevices.getUserMedia(constraints);
    }

    // Store the new stream
    setCurrentStream(stream);

    // Enumerate devices
    const devices = await navigator.mediaDevices.enumerateDevices();
    const audioDevices = devices.filter((d) => d.kind === "audioinput");
    const videoDevices = devices.filter((d) => d.kind === "videoinput");

    setDevices({ audio: audioDevices, video: videoDevices });

    if (audioDevices.length > 0) setSelectedAudioDevice(audioDevices[0].deviceId);
    if (videoDevices.length > 0) setSelectedVideoDevice(videoDevices[0].deviceId);

    // Update state to reflect success
    setPermissionsModalVisible(false);
    setAudioDenied(false);
    setVideoDenied(false);

    // Set the video stream to the video element
    if (videoRef.current) videoRef.current.srcObject = stream;
  } catch (error) {
    console.error("Error requesting media permissions:", error);
    
    // Detailed error handling
    if (error.name === 'NotAllowedError') {
      // User has explicitly denied permissions
      console.log("Permissions denied by the user.");
      setAudioDenied(true);
      setVideoDenied(true);
      // You can show a more specific modal here
    } else if (error.name === 'NotFoundError') {
      // No camera or microphone was found
      console.log("No media devices found.");
      setAudioDenied(true);
      setVideoDenied(true);
    } else if (error.name === 'OverconstrainedError') {
      // A constraint could not be met
      console.log("OverconstrainedError: A specific constraint could not be satisfied.");
      setAudioDenied(true);
      setVideoDenied(true);
    } else {
      // Generic error
      console.log("An unexpected error occurred.");
      setAudioDenied(true);
      setVideoDenied(true);
    }

    // Show a generic modal for all other errors
    setShowModal(true);
  }
};
  const startStream = async (deviceId, type) => {
    try {

      let constraints;
      if (type === "video") {
        await stopCurrentStream(); // Ensure previous stream is stopped

        constraints = {
          video: { facingMode: { ideal: role === 2 ? "environment" : "user" }, },
        };
      } else if (type === "audio") {
        constraints = {
          audio: { deviceId: { exact: deviceId } },
        };
      }

      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      setCurrentStream(stream); // Store the new stream
      if (type === "video" && videoRef.current) {
        videoRef.current.srcObject = stream; // Assign the stream to the video element
      }
      onDeviceSelection({ audioDeviceId: selectedAudioDevice, videoDeviceId: selectedVideoDevice });
    } catch (error) {
      console.error(`Error accessing ${type} device:`, error);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, []);

  useEffect(() => {
    if (selectedVideoDevice) startStream(selectedVideoDevice, "video");
  }, [selectedVideoDevice]);

  useEffect(() => {
    if (selectedAudioDevice) startStream(selectedAudioDevice, "audio");
  }, [selectedAudioDevice]);

  function handleCheckboxChange(event) {
    console.log(event.target.checked)
    dispatch(setRecordingPermission(event.target.checked));
  }

   useEffect(() => {
        // navigator.mediaDevices.enumerateDevices()
        //     .then(devices => {
        //         const audioDevices = devices.filter(device => device.kind === 'audioinput');
        //         const videoDevices = devices.filter(device => device.kind === 'videoinput');
        //         console.log(audioDevices, videoDevices,"kkkk");
        //         setDevices({ audio: audioDevices, video: videoDevices });
        //         if (audioDevices.length > 0) {
        //             setSelectedAudioDevice(audioDevices[0].deviceId);
        //         }
        //         if (videoDevices.length > 0) {
        //             setSelectedVideoDevice(videoDevices[0].deviceId);
        //         }
        //     })
        //     .catch(error => console.log(error));
    }, []);

    useEffect(() => {
        // const constraints = {
        //     video: { deviceId: selectedVideoDevice ? { exact: selectedVideoDevice } : undefined }
        // };
        // navigator.mediaDevices.getUserMedia(constraints)
        //     .then(stream => {
        //         videoRef.current.srcObject = stream;
        //     })
        //     .catch(error => console.error('Error accessing media devices:', error));
    }, [ selectedVideoDevice]);

    useEffect(() => {
        const constraints = {
            audio: { deviceId: selectedAudioDevice ? { exact: selectedAudioDevice } : undefined },
        };
        navigator.mediaDevices.getUserMedia(constraints)
            .then(stream => {
                setupAudioAnalysis(stream);
            })
            .catch(error => console.error('Error accessing media devices:', error));
    }, [selectedAudioDevice]);

    const setupAudioAnalysis = (stream) => {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const analyser = audioContext.createAnalyser();
        const microphone = audioContext.createMediaStreamSource(stream);
        microphone.connect(analyser);
        analyserRef.current = analyser;
        audioContextRef.current = audioContext;
        animateAudioLevel();
    };

    const animateAudioLevel = () => {
        const analyser = analyserRef.current;
        const dataArray = new Uint8Array(analyser.frequencyBinCount);
        analyser.getByteTimeDomainData(dataArray);
        let sum = 0;
        for (let i = 0; i < dataArray.length; i++) {
            const value = dataArray[i] / 128 - 1;
            sum += value * value;
        }
        const average = Math.sqrt(sum / dataArray.length);
        const normalizedLevel = Math.min(average / 0.1, 1); // Normalize and clamp the value
        setAudioLevel(normalizedLevel);
        animationFrameIdRef.current = requestAnimationFrame(animateAudioLevel);
    };


    function saveCallDurationForRegisteredCustomer() {

        setSaveCallDurationLoading(true);
        const data = new FormData();
          data.append("user_id_ids", localStorage.getItem("user_id") || "");
    
        data.append("call_log_id_ids", serviceDetailsObj?.calls[0]?.call_log_id_ids);
        data.append("joinee_name_chr", userName);
        data.append("call_duration_in_second", 1);
        data.append("after_free_time_flag", 1);
    
    
        dispatch(saveCallDurationApi(data, (res) => {
          console.log(res)
          setSaveCallDurationLoading(false);

          handleSubmit();
        }, (err) => {
          console.log(err);
          setSaveCallDurationLoading(false);

          setPaymentErrorStatusCode(err.status);

          setPaymentErrorModalTrigger(true);

          setResponceMsg(err.data.message);
              setToasterType("error");
      
              // setHandleToaster(true);
              // setTimeout(() => {
              //   setHandleToaster(false);
              // }, 11000);
        }))
      }

      const getServiceDetailsFn = () => {
          let details = {
            ticket_id_ids: localStorage.getItem("ticket_id"),
          };
          dispatch(
            ticketDetailsApi(details, (res) => {
              // console.log(res);
      
              setServiceDetailsObj(res?.data);
      
           
            }, (res) => {
      
              setResponceMsg(res.data.message);
              setToasterType("error");
      
              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
      
            })
          );
        };

  useEffect(()=>{
  if (authorized) {
    if (permissionArray.includes("CONNECT TO PRO") && localStorage.getItem("ticket_id")) {
        getServiceDetailsFn();
      }
    }
  }, [])

  return (
    <div 
    className="container-fluid pt-3"
    style={{
      background: "linear-gradient(182deg, rgba(250, 238, 227, 0.67) 33%, rgb(255, 255, 255) 85%)"
    }}
    >
      <div>
        <img src={chill} width={"90px"} alt="Logo" />
      </div>
      <div className="row justify-content-center" style={{ height: `calc(100vh - 90px)` }}>
        <div className="col-lg-6 col-md-12" style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
          {role === 2 &&
              <div className="text-center mb-4 font-w600">
                <span>{`For an optimal experience, clean your camera lens and be sure to connect to wi-fi`}</span>
              </div>
            }
            
          <div className="video-container">
            <video
              ref={videoRef}
              autoPlay
              playsInline
              muted
              className="video-element"
              style={{ background: "black", borderRadius: "7px" }}
            ></video>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', position: 'absolute', top: '0', gap: '10px' }}>
              {videoDenied && (
                <div className="alert alert-danger mt-2" style={{ background: 'white' }}>
                  <p>
                    Video permission denied.
                  </p>
                  <PrimaryButton buttonName="Retry" onClick={() => handleRetry("video")} />
                </div>
              )}
              {audioDenied && (
                <div className="alert alert-danger mt-2" style={{ background: 'white' }}>
                  <p>
                    Audio permission denied.
                  </p>
                  <PrimaryButton buttonName="Retry" onClick={() => handleRetry("audio")} />

                </div>
              )}
            </div>
          </div>
          <div className="settings justify-content-center">
            <div className="col-md-12 select-container d-flex flex-column  ">
   
              <div className="d-flex align-items-center">
                              
                <BsMicFill className="icon" style={{ marginRight: "10px" }} size={20} />
                <select
                  className="form-control device-select"
                  onChange={(e) => setSelectedAudioDevice(e.target.value)}
                  value={selectedAudioDevice}
                >
                  {devices.audio.map((device) => (
                    <option key={device.deviceId} value={device.deviceId}>
                      {device.label || "No device found"}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mt-2 fs-7">
                <span className="d-flex justify-content-between" style={{gap:"9px"}}>               {devices?.audio[0]?.deviceId && <div className="audio-meter">
                  <div className="bar1" style={{ transform: `scaleY(${audioLevel})` ,left:'7px'}}></div>
                  <div className="bar" style={{ transform: `scaleY(${audioLevel})` }}></div>
                  <div className="bar1" style={{ transform: `scaleY(${audioLevel})`,left:'23px' }}></div>
              </div>}{`Test the microphone by speaking`}</span>
              </div>

            </div>
            <div className="col-md-12 select-container d-flex flex-column ">
              <div className="d-flex align-items-center">
                <BsCameraFill className="icon" style={{ marginRight: "10px" }} size={20} />
                <select
                  className="form-control device-select"
                  onChange={(e) => setSelectedVideoDevice(e.target.value)}
                  value={selectedVideoDevice}
                >
                  {devices.video.map((device) => (
                    <option key={device.deviceId} value={device.deviceId}>
                      {device.label || "No camera found"}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mt-2 fs-7">
                <span>{`If you can see yourself, your video is working fine`}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-12" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <div className="join-section text-center" style={{ marginLeft: '10px' }}>
            <h3 className="mb-4">{`Participants in call`}</h3>

            

            

            {participantsData.length > 0 ? (
              <div className="d-flex" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div className="d-flex">
                  {participantsData.map((name) => (
                    <span
                      key={name}
                      style={{
                        color: "white",
                        height: "30px",
                        width: "30px",
                        borderRadius: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "5px",
                        backgroundColor: "var(--primary)",
                        marginBottom: "7px",
                      }}
                    >
                      {name.charAt(0)}
                    </span>
                  ))}
                </div>
                <p>{participantsData.join(", ")} is in the call</p>
              </div>
            ) : (
              <p>No one in the call yet</p>
            )}
            <div className="d-flex flex-column align-items-start">
              <InputField labelName={"Name"} onChange={onChange} value={value} errorOccured={errorOccured} errorMeesage={`Name is required`} isRequired={true} />
            </div>
            <PrimaryButton 
              buttonName={"JOIN VIDEO CALL"}
              onClick={() =>{
                // Save call duration for registered customer if the remaining time is 0 is commented for now as payment flow shifted to connectToPro api

                // if(permissionArray.includes("CONNECT TO PRO") && Object.keys(serviceDetailsObj)?.length > 0){ 
                //   if(serviceDetailsObj?.calls[0]?.call_log_id_ids && 
                //     localStorage.getItem("user_id") &&
                //     serviceDetailsObj?.remaining_time_in_sec == 0){
                //     saveCallDurationForRegisteredCustomer();
                //   } else {
                //     handleSubmit();
                //   }
                // } else {
                //   handleSubmit();
                // }

                handleSubmit();
              }} 
              isLoading={isLoading || saveCallDurationLoading} 
              loadingMessage={"Joining"} 
              style={{
                width: "100%",
                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                border: '1px solid rgba(255, 154, 32, 1)',
                fontWeight: '600',
              }}
             />
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: '10px', marginBottom: '10px' }}>
              <input
                type="checkbox"
                id="consent"
                checked={recordingPermission}
                onChange={handleCheckboxChange}
                className="form-check-input"
              />
              <p
                htmlFor="consent"
                style={{
                  fontSize: "14px",
                  margin: '0px',
                  marginTop: "0.25em"
                }}
              >
                I consent to have this video call recorded.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Modal show={showModal} centered onHide={() => setShowModal(false)} size="lg">
        {/* <Modal.Header closeButton></Modal.Header> */}
        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0 d-flex justify-content-end">
              <span
                className="font-w600 text-black text-hovered cursor-pointer fs-4"
                onClick={() => setShowModal(false)}
              >
                <i className='bi bi-x-lg' />
              </span>
            </div>
          </div>
          {/* <img src={googleImg} alt="Logo" style={{ width: '100%' }} /> */}


          <div className="row mx-0">
            <div className="col-12 px-3">
              <div className="mb-2 d-flex justify-content-center align-items-center">
                <span className="fs-3 font-w600 text-black text-center">{`Chilll is blocked from using your microphone or camera`}</span>
              </div>

              <div className="mb-4 d-flex justify-content-center align-items-center">
                <span className="text-center">{`Please follow instructions as given in video to allow access to your microphone and camera`}</span>
              </div>
            </div>


            <div className="col-12">

              {
                deviceType === 'desktop' ?
                  (
                    <>
                      <div data-video-id="25653" className="rounded-2 shadow-lg" style={{ aspectRatio: 1.80377358, overflow: 'hidden', }}>
                        <iframe
                          className="rounded-2"
                          width="100%"
                          height="100%"
                          src="https://app.vidzflow.com/v/ZfwCs2Vo80?dq=576&ap=true&muted=true&loop=true&ctp=false&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen"
                          title="Camera Mic Permission"
                          style={{ aspectRatio: 1.80377358, overflow: 'hidden' }}
                          frameborder="0"
                          scrolling="no"
                          allow="fullscreen"></iframe>
                      </div>
                    </>
                  ) : (
                    osType === 'android' ?
                      (
                        <>
                          <div data-video-id="36223" style={{ aspectRatio: 0.56250000, overflow: 'hidden' }}>

                            <iframe
                              className="rounded-2"
                              width="100%"
                              height="100%"
                              src="https://app.vidzflow.com/v/ciuBEbfQ1x?dq=576&ap=true&muted=true&loop=true&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen"
                              title="WhatsApp Video 2025-06-17 at 1.45.40 PM"
                              style={{ aspectRatio: 0.56250000, overflow: 'hidden' }}
                              frameborder="0"
                              scrolling="no"
                              allow="fullscreen"></iframe>
                          </div>
                        </>
                      ) : (
                        <>
                          <div data-video-id="36223" style={{ aspectRatio: 0.56250000, overflow: 'hidden' }}>

                            <iframe
                              className="rounded-2"
                              width="100%"
                              height="100%"
                              src="https://app.vidzflow.com/v/ciuBEbfQ1x?dq=576&ap=true&muted=true&loop=true&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen"
                              title="WhatsApp Video 2025-06-17 at 1.45.40 PM"
                              style={{ aspectRatio: 0.56250000, overflow: 'hidden' }}
                              frameborder="0"
                              scrolling="no"
                              allow="fullscreen"></iframe>
                          </div>
                        </>
                      )
                  )
              }
            </div>



          </div>



        </Modal.Body>
      </Modal>
      <Modal show={permissionsModalVisible} centered onHide={() => setPermissionsModalVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Permissions Needed</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Please allow access to your microphone and camera to proceed.</p>
          <PrimaryButton buttonName="Allow Access" onClick={requestMediaPermissions} />
        </Modal.Body>
      </Modal>

      

        <Modal show={paymentErrorModalTrigger} centered>
          
          <Modal.Body>
           <div className='row mx-0'>
              <div className='col-12 px-0'>
                  <>
                    <div className='mx-0 row text-black mb-3'>
                        <div className='col-12 font-w600 fs-4 px-0 text-center'>
                            <img src={serviceImg} alt="" style={{ maxWidth: '150px' }} />
                        </div>
                    </div>

                    <div className='mx-0 row text-black mb-3'>
                        <div className='col-12 font-w600 fs-4 px-0 text-center'>
                            <span>
                                {responceMsg || 'Something went wrong, please try after some time.'}
                            </span>
                        </div>

                    </div>

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            <PrimaryButton
                                onClick={() => {
                                  if(paymentErrorStatusCode == 402){
                                    navigate('/userProfile');
                                    dispatch(setUserProfileTab(3));
                                  }
                                  setPaymentErrorModalTrigger(false);
                                }}
                                buttonName={"ADD PAYMENT METHOD"}
                                type="submit"
                                loadingMessage="SUBMITTING..."
                                isLoading={false}
                                style={{
                                    width: "100%",
                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                    border: '1px solid rgba(255, 154, 32, 1)',
                                    fontWeight: '600',
                                }}
                            />
                        </div>
                    </div>
                  </> 
              </div>
            </div>
          </Modal.Body>
        </Modal>



            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}
      
    </div>
  );
};

export default VideoCallPreview;



// import React, { useEffect, useState, useRef } from 'react';
// import './VideoCallPreview.css';
// import chill from "../../../icons/photos/chillLogo.png"
// import { Bs0Circle, BsCameraFill, BsCameraVideo, BsMicFill } from 'react-icons/bs';
// import InputField from '../../../jsx/components/fields/inputField';
// import PrimaryButton from '../../../jsx/components/button/primaryButton';
// import { useSelector,useDispatch } from 'react-redux';
// import { getParticipantsApi } from '../../../service/api/video/getParticipant';
// import { useToast } from 'react-toastify';
// import GreenButton from '../../../jsx/components/button/greenButton';

// const VideoCallPreview = ({ onChange, value, errorOccured, handleSubmit,isLoading }) => {
//     const dispatch = useDispatch()
//     const { authorized } = useSelector(state => state.auth);
//     const [devices, setDevices] = useState({ audio: [], video: [] });
//     const [selectedAudioDevice, setSelectedAudioDevice] = useState('');
//     const [selectedVideoDevice, setSelectedVideoDevice] = useState('');
//     const [participantsData,setParticipantsData] = useState([])
//     const [audioLevel, setAudioLevel] = useState(0);
//     const videoRef = useRef(null);
//     const audioContextRef = useRef(null);
//     const analyserRef = useRef(null);
//     const animationFrameIdRef = useRef(null);
      

//     useEffect(()=>{
//         var data ={
//             video_token_chr : localStorage.getItem("roomCode")
//         }
//  dispatch(getParticipantsApi(data,(res)=>{
//     console.log(res.data)
//     setParticipantsData(res.data.data)

//  },()=>{}))
//     },[])

//     useEffect(() => {
//         navigator.mediaDevices.enumerateDevices()
//             .then(devices => {
//                 const audioDevices = devices.filter(device => device.kind === 'audioinput');
//                 const videoDevices = devices.filter(device => device.kind === 'videoinput');
//                 console.log(audioDevices, videoDevices,"kkkk");
//                 setDevices({ audio: audioDevices, video: videoDevices });
//                 if (audioDevices.length > 0) {
//                     setSelectedAudioDevice(audioDevices[0].deviceId);
//                 }
//                 if (videoDevices.length > 0) {
//                     setSelectedVideoDevice(videoDevices[0].deviceId);
//                 }
//             })
//             .catch(error => console.log(error));
//     }, []);

//     useEffect(() => {
//         const constraints = {
//             video: { deviceId: selectedVideoDevice ? { exact: selectedVideoDevice } : undefined }
//         };
//         navigator.mediaDevices.getUserMedia(constraints)
//             .then(stream => {
//                 videoRef.current.srcObject = stream;
//             })
//             .catch(error => console.error('Error accessing media devices:', error));
//     }, [ selectedVideoDevice]);

//     useEffect(() => {
//         const constraints = {
//             audio: { deviceId: selectedAudioDevice ? { exact: selectedAudioDevice } : undefined },
//         };
//         navigator.mediaDevices.getUserMedia(constraints)
//             .then(stream => {
//                 setupAudioAnalysis(stream);
//             })
//             .catch(error => console.error('Error accessing media devices:', error));
//     }, [selectedAudioDevice]);

//     const setupAudioAnalysis = (stream) => {
//         const audioContext = new (window.AudioContext || window.webkitAudioContext)();
//         const analyser = audioContext.createAnalyser();
//         const microphone = audioContext.createMediaStreamSource(stream);
//         microphone.connect(analyser);
//         analyserRef.current = analyser;
//         audioContextRef.current = audioContext;
//         animateAudioLevel();
//     };

//     const animateAudioLevel = () => {
//         const analyser = analyserRef.current;
//         const dataArray = new Uint8Array(analyser.frequencyBinCount);
//         analyser.getByteTimeDomainData(dataArray);
//         let sum = 0;
//         for (let i = 0; i < dataArray.length; i++) {
//             const value = dataArray[i] / 128 - 1;
//             sum += value * value;
//         }
//         const average = Math.sqrt(sum / dataArray.length);
//         const normalizedLevel = Math.min(average / 0.1, 1); // Normalize and clamp the value
//         setAudioLevel(normalizedLevel);
//         animationFrameIdRef.current = requestAnimationFrame(animateAudioLevel);
//     };
//     return (
//         <div className="container-fluid mt-3">
//             <div>
//                 <img src={chill} width={"90px"}/>
//             </div>
    
//             <div className="row justify-content-center" style={{height: `calc(100vh - 90px)`}}>
//                 <div className="col-lg-6 col-md-12" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
//                     <div className="video-container">
//                         <video ref={videoRef} autoPlay playsInline muted className="video-element" style={{background: 'black', borderRadius: '7px'}}></video>
//                        {devices?.audio[0]?.deviceId && <div className="audio-meter">
//     <div className="bar1" style={{ transform: `scaleY(${audioLevel})` ,left:'7px'}}></div>
//     <div className="bar" style={{ transform: `scaleY(${audioLevel})` }}></div>
//     <div className="bar1" style={{ transform: `scaleY(${audioLevel})`,left:'25px' }}></div>
// </div>}
//                     </div>
//                     <div className=" settings d-flex justify-content-center">
    
//                         <div className="col-md-12 select-container d-flex justify-content-center align-items-center">
//                             <BsMicFill className="icon" style={{marginRight: '10px'}} size={20}/>
//                             <select className="form-control device-select" onChange={e => setSelectedAudioDevice(e.target.value)} value={selectedAudioDevice}>
//                                 {devices.audio.map((device, index) => (
//                                     <option key={device.deviceId} value={device.deviceId}>{device.label || `No device Found `}</option>
//                                 ))}
//                             </select>
//                         </div>
//                         <div className="  col-md-12 select-container d-flex justify-content-center align-items-center">
//                             <BsCameraFill style={{marginRight: '10px'}} className="icon" size={20}/>
//                             <select className="form-control device-select" onChange={e => setSelectedVideoDevice(e.target.value)} value={selectedVideoDevice}>
//                                 {devices.video.map((device, index) => (
//                                     <option key={device.deviceId} value={device.deviceId}>{device.label || `No Camera Found`}</option>
//                                 ))}
//                             </select>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="col-lg-4 col-md-12" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
//                     <div className="join-section text-center">
//                         <div className='mb-5 d-flex' style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
//                            <h3 className='mb-4'>Chilll video call</h3>
//                          {  participantsData.length >0 &&<div className='d-flex'>
//                             {participantsData.map((res)=>(

//                            <span style={{color: "white", height: "30px", width: "30px", borderRadius: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: '5px', backgroundColor: "var(--primary)", marginBottom: '7px'}}>{res.charAt(0)}</span>
//                             ))}

//                            </div>}
//                           { participantsData.length >0 && <span>
//                                { participantsData.length == 1 ? participantsData[0] : `${participantsData[0]} and ${participantsData[1]}` } is in call
//                             </span>}
//                             { participantsData.length ==0 && <h7>
//                              No one is in the call yet
//                             </h7>}
//                         </div>
//                         <InputField labelName={"Name"} onChange={onChange} value={value} errorOccured={errorOccured}/>
//                         <GreenButton buttonName={"JOIN VIDEO CALL"} onClick={handleSubmit} loadingMessage={"Joining"} isLoading={isLoading}/>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default VideoCallPreview;
